<ng-container *ngIf="dialogShown$ | async" >
    <ng-container *ngTemplateOutlet="dialog; context: dataContext"></ng-container>
</ng-container>

<ng-template #dialog let-data let-showCloseButton>
    <div class="nsw-dialog js-dialog active" id="danger" role="dialog" aria-labelledby="danger-title" aria-expanded="true"  aria-modal="true">
        <div class="nsw-dialog__wrapper">
            <div class="nsw-dialog__container">
                <div class="nsw-dialog__top">
                <div class="nsw-dialog__title">
                    <h2 id="danger-title">Delete file permanently?</h2>
                </div>
                </div>
                <div class="nsw-dialog__content">
                    <p>If you delete this file, you will not be able to recover it. Do you want to delete?</p>
                </div>
            </div>
            <div class="nsw-dialog__bottom">
                    <button class="nsw-button nsw-button--dark nsw-button--danger js-close-dialog" aria-current="true" [tabIndex]="1">Delete</button>
                    <button class="nsw-button nsw-button--dark-outline-solid js-close-dialog"  [tabIndex]="2">Cancel</button>
            </div>
        </div>
    </div>


    <!-- <div id="dismissible" role="dialog" #containerDiv
        aria-labelledby="dismissible-title" aria-modal="true" 
        class="nsw-dialog js-dialog js-dialog-dismiss active">
        <div class="nsw-dialog__wrapper">
            <div class="nsw-dialog__container">
                <div class="nsw-dialog__top">
                    <div class="nsw-dialog__title">
                        <h2 id="dismissible-title" [tabindex]="0" style="color:black;">{{data?.title}}</h2>                        
                    </div>
                    <div class="nsw-dialog__close" *ngIf="data?.showCloseButton" >
                        <button class="nsw-icon-button js-close-dialog" (click)="onCancelClicked($event)" #closeButton  [tabindex]="0">
                            <span class="material-icons nsw-material-icons" focusable="false"
                                aria-hidden="true">close</span>
                            <span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>
                <div class="nsw-dialog__content">                    
                    <p style="color:black;">{{data?.content}}</p>
                </div>
            </div>
            <div class="nsw-dialog__bottom">
                <button role="button" class="nsw-button nsw-button--dark js-close-dialog" [tabindex]="0" focusable="true" (click)="onCancelClicked($event)"  #cancelButton>
                    {{data?.cancelButtonText}}
                </button>
                <button  role="button" class="nsw-button nsw-button--dark-outline-solid js-close-dialog" [tabindex]="0" (click)="onAcceptClicked($event)" #acceptButton>
                    {{data?.acceptButtonText}}
                </button>
                
            </div>
        </div>
    </div> -->

</ng-template>
